export const TELEGRAM_MINI_APP_URL =
  process.env.REACT_APP_TELEGRAM_MINI_APP_URL || 'https://t.me/sandrapay_bot';
